module.exports = __webpack_public_path__ + "static/section_check_info2-da95505d4287f1c875f297e090f6231c.png";